module.exports = __webpack_public_path__ + "header.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/header.png
 ** module id = 338
 ** module chunks = 0
 **/